import React, { useEffect, useState, useRef } from "react";
import "./stats.scss";

const Stats = () => {
  const [counts, setCounts] = useState({ lessons: 0, additional: 0, lab: 0 });
  const targetCounts = { lessons: 32, additional: 10, lab: 5 };
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.7 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      setCounts({ lessons: 0, additional: 0, lab: 0 });
      const interval = setInterval(() => {
        setCounts((prevCounts) => {
          const newCounts = { ...prevCounts };
          if (newCounts.lessons < targetCounts.lessons) newCounts.lessons++;
          if (newCounts.additional < targetCounts.additional)
            newCounts.additional++;
          if (newCounts.lab < targetCounts.lab) newCounts.lab++;
          return newCounts;
        });
      }, 50);

      return () => clearInterval(interval);
    } else {
      setCounts({ lessons: 0, additional: 0, lab: 0 });
    }
  }, [isVisible]);

  return (
    <div id="stats_div" ref={ref}>
      <div id="lessons_module">
        <h2>{counts.lessons} lekcje</h2>
        <p>w 5 tematycznych modułach</p>
      </div>
      <div id="additional_hours_module">
        <h2>{counts.additional}+ godzin</h2>
        <p>dodatkowo na spotkania live</p>
      </div>
      <div id="lab_module">
        <h2>{counts.lab}+ lat</h2>
        <p>pracy nad doskonaleniem tego rozwiązania</p>
      </div>
    </div>
  );
};

export default Stats;
